import { FunctionComponent } from 'react';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { useAuth } from 'hooks';

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        container: {
            display: 'block',
            justifyContent: 'center',
            background: 'white',
            height: '100%',
            width: '100%'
        },
        iframe: {
            width: '100%',
            height: '100%',
            border: 'none'
        }
    })
);

export const Dashboard: FunctionComponent = () => {
    const classes = useStyles();
    const auth = useAuth();

    const inventoryDashboardUrl = `${process.env.REACT_APP_HOST_URL}${process.env.REACT_APP_WEB_BASE_URL}inventory_dashboard?access_token=${auth.token}&marketplace_id=${auth.marketplaceId}`;

    return (
        <Box className={classes.container}>
            <iframe
                title="Inventory Dashboard"
                className={classes.iframe}
                src={inventoryDashboardUrl}
            ></iframe>
        </Box>
    );
};

export default Dashboard;
